/**
 * Builds the /api/v1 base from REACT_APP_API_URL, which is configured with the
 * suffix already attached in some environments and without it in others.
 * Appending it unconditionally yields /api/v1/api/v1/... — the reason document
 * version history 404'd on every request.
 */
export function apiV1Base(base: string): string {
  const trimmed = base.replace(/\/+$/, '');
  return trimmed.endsWith('/api/v1') ? trimmed : `${trimmed}/api/v1`;
}

export const API_V1 = apiV1Base(process.env.REACT_APP_API_URL || window.location.origin);
